import React, { useContext } from 'react';
import { FilterEditorContext } from '../../../../components/filter-editor/context';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import GridRow from './grid-row';
import style from './style.module.less';

const GridRows = () => {
  const { filterSets, isLoadingFilters } = useContext(FilterEditorContext);
  return (
    <>
      {isLoadingFilters && <LoadingIndicator className={style.loading} />}
      {!isLoadingFilters &&
        filterSets &&
        Object.values(filterSets)
          .filter((filt) => filt.active)
          .map((filter) => <GridRow key={filter.orderFilterSetId} orderFilterSetId={filter.orderFilterSetId} />)}
    </>
  );
};

export default GridRows;
